import React, { useState, useEffect, useRef } from 'react'
import { format } from 'date-fns'
import "../scss/claimHistory.scss";
import "../scss/gisSurvey.scss"
import { formatDistance } from 'date-fns'
import LoadingPage from '../reusableComponents/loader/loadingPage';
import NoDataFound from '../utilsComponent/noDataFound';
import { useNavigate } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import {OverlayTrigger, Tooltip } from 'react-bootstrap';
import GisSurveyRequest from './gisSurveyRequest';
import { downloadNDVI, editModeOn, firstLetterCapital, getFromLocalStorage, getLatLngArray, saveInLocalStorage } from '../utilFunctions';
import Colors from '../utilsComponent/colors';
import Select, {components } from 'react-select';
import GMap from '../utilsComponent/GMap';
import { APIProvider } from '@vis.gl/react-google-maps';
import ViewImagePopup from '../utilsComponent/ViewImagePopup';
import { FIELD_SURVEY_IMAGE_KEY_VALUE, functionalities, GIS_REPORT_TYPE_ARRAY, GOOGLE_MAP_API_KEY, IMAGE_TYPE, MAP_DEFAULT_CENTER, RECLOSE } from '../consts';
import { getClaimDocuments, getClaimIntimationImageCoordinates, getFieldSurveyData, getFieldSurveyImageCoordinates, getFieldSurveyList, getGEOTagImageCoordinates, getGisSurveyList, getGisSurveyUsingGISNo, getPolicyPolygon, saveFieldSurveyImageCoordinates, startClaimIntimationImageCoordinatesService, startFieldSurveyImageCoordinatesService } from './apiHelper';
import ViewMoreLess from '../reusableComponents/ViewMoreLess';
import GisSurveyChart from '../utilsComponent/GisSurveyChart';
import Accordion from 'react-bootstrap/Accordion';

const legendItems = [
    { className: 'line-policy', label: 'Policy Polygon' },
    { className: 'line-arable', label: 'Arable Polygon' },
    { className: 'box-damage', label: 'Damage' },
    { className: 'box-no-damage', label: 'No Damage' },
    { className: 'box-flood', label: 'Flood' },
    { className: 'box-no-flood', label: 'No Flood' },
  ];
const MAP_CATEGORY_LIST = [
    {
      value: "arable_polygon",
      label: "Arable Polygon",
    },
    {
      value: "damage_map",
      label: "Damage Map",
    },
    
  ];
const fixedOptions = [
    {
        value: "policy_polygon",
        label: "Policy Polygon",
    },
]
const floodMapOption = {
    value: "flood_map",
    label: "Flood Map",
}
const MAP_CATEGORY_OPTION = [
    ...fixedOptions,
    ...MAP_CATEGORY_LIST,
]
const SOWN = 'sown';
const HEALTH = 'health'
const GisSurvey = (props) => {
    const {comditionalStatusForGisAndField, claimDetailCookie, policyDetailCookie, getClaimDetails, roleDataCookie} = props;
    const [gisSurveylists,setGisSurveyLists]=useState([]);
    const [gisSurveyData, setGisSurveyData]= useState(getFromLocalStorage("gis_id") ? getFromLocalStorage("gis_id") : null);
    const [loading,setLoading]=useState(false)
    const [gISImages, setGISImages] = useState([])
    const [polygonData, setPolygonData] = useState([])
    const [floodDateOptions, setFloodDateOption] = useState([]) 
    const [floodMapImages, setFloodMapImages] = useState({});
    const [selectedFloodDate, setSelectedFloodDate] = useState();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(null);
    const [imagesNameArray, setFieldSurveyImages] = useState({});
    const [imagesLatitudeLongitude, setImagesLatitudeLongitude] = useState(null);
    const [mapCategory, setMapCategory] = useState(fixedOptions);
    const [polygonPositionsArray, setPolygonPositionsArray] = useState([]);
    const [pngMapImageArray, setPngMapImageArray] = useState([]);
    const [gisReportName, setGisReportName] = useState({value:'all', label: 'All'});
    const [mapCenter, setMapCenter] = useState(MAP_DEFAULT_CENTER);
    const [mapCategoryOptions, setMapCategoryOptions] = useState(MAP_CATEGORY_OPTION);    
    const giSSurveyAPIProgressRef = useRef(false);
  
    const fetchImageCoordinates = async (imageNameArray) => {
        if (imageNameArray?.length) {
            const imageDetails = await getFieldSurveyImageCoordinates(imageNameArray);
            if (imageDetails?.data && Object.keys(imageDetails.data).length > 0) {
                setImagesLatitudeLongitude(imageDetails.data);
            }
        }
    };
  
  const onMapCategoryChange = (selected, isFloodDateSelected) =>{
    const filtered = selected.filter(option => 
        !fixedOptions.some(fixed => fixed.value === option.value)
      );
      setMapCategory([...fixedOptions, ...filtered]);
  }

  const removeFloodMapCategory = () =>{
    const filtered = mapCategory.filter(option => option.value !== floodMapOption.value);
     setMapCategory(filtered);
  }

  const prepareMapPolygonDataArray = ()=>{
    const polygonArray = [];
    const pngMapImages = []
    const colorMapping = {
      policy_polygon: 'black',
      arable_polygon: '#D0FE1D',
      damage_map: 'red',
      flood_map: 'blue',
    };
    for(const category of mapCategory){
        if (category?.value) {
            if(category?.value === 'arable_polygon'){
                polygonArray.push({
                    polygonArray:  getLatLngArray(gisSurveyData?.jsonResponse?.Arable_polygon),
                    color: colorMapping[category?.value],
                });
            } else if(category?.value === 'policy_polygon'){
                polygonArray.push({
                    polygonArray: polygonData,
                    color: colorMapping[category?.value],
                });
            }  else if(category?.value === 'damage_map'){
                pngMapImages.push({
                    polygonArray: polygonData,
                    url: gisSurveyData?.jsonResponse?.png_damage,
                })
            } else if(category?.value === floodMapOption.value && selectedFloodDate?.value){
                 pngMapImages.push({
                    polygonArray: polygonData,
                    url: floodMapImages[selectedFloodDate.value],
                })
            }
          }
    }
    setMapCenter(polygonData[0]);
    setPngMapImageArray(pngMapImages);
    setPolygonPositionsArray(polygonArray);
  }

  const onSelectedFloodDateChange = (data)=>{
    setSelectedFloodDate(data);
    if(data){
        const filtered = mapCategoryOptions.filter(option => option.value !== floodMapOption.value);
        const index = mapCategoryOptions.length - 1;
        setMapCategoryOptions([...filtered.slice(0, index), ...[floodMapOption], ...filtered.slice(index)])
    }else{
        setMapCategoryOptions(mapCategoryOptions.filter(option => option.value !== floodMapOption.value));
        removeFloodMapCategory();
    }
  }
  
  useEffect(() => {
    if(mapCategory){
        prepareMapPolygonDataArray();
    }
  }, [mapCategory, polygonData, selectedFloodDate]);
  
    useEffect(() => {
        getClaimDetails(claimDetailCookie.claimNo)
        getFromLocalStorage("gis_id") && getGISSurveyData(getFromLocalStorage("gis_id"))
    },[])
    const getPolygonData = async () => {  
        const response = await getPolicyPolygon(policyDetailCookie);  
        if(response?.data?.features[0]?.geometry?.coordinates[0]){
            const polygonLists =  response.data.features[0].geometry.coordinates[0]
            const updatedData = polygonLists && polygonLists.length > 0 && polygonLists.map(list => {
                return {
                    lat: list[1],
                    lng: list[0]
                }
             }
            )
           setPolygonData(updatedData);
      }

    }
    
    const calculateAge=(date)=>{
        const currentDate = new Date();
        const recordDate = new Date(date);
        const dateDiff = currentDate.getTime() - recordDate.getTime();
        const daysDiff = Math.floor(dateDiff / (1000 * 60 * 60 * 24));
        return daysDiff;
    }
    const updateWaterDate = (data)=>{
        try{
            const png_water = data?.data?.jsonResponse?.png_water;
            const floodMap = {};
            const waterDates = data?.data?.jsonResponse?.Water_dates || '';
            let waterDatesArray =   null;
                if(waterDates){
                    waterDatesArray = JSON.parse(waterDates.replace(/'/g, '"'));
                }
                if(waterDatesArray && Array.isArray(waterDatesArray)){
                    const arrayKeyValue = [];
                    waterDatesArray.forEach((item, index)=>{
                        const formatedValue = format(new Date(item), 'dd-MM-yyyy');
                        arrayKeyValue.push({
                            label: formatedValue,
                            value: formatedValue
                        });
                        floodMap[formatedValue] = png_water[index]; // for each date, one image will be available
                    })
                    setFloodDateOption(arrayKeyValue);
                    setFloodMapImages(floodMap);
             }
        }catch(err){

        }
    }

    const prepareClaimAndFieldSurveyImageParam = (fieldSurveyData, claimDocuments)=>{
        const imageParamArray = [];
        const fieldSurveyImages = [];
        const claimsImages = [];
        if(fieldSurveyData){  
            Object.keys(FIELD_SURVEY_IMAGE_KEY_VALUE).forEach(key => {
                if(fieldSurveyData?.jsonResponse && fieldSurveyData?.jsonResponse[key]){
                    imageParamArray.push(fieldSurveyData?.jsonResponse[key]);
                    fieldSurveyImages.push({
                        imageText: FIELD_SURVEY_IMAGE_KEY_VALUE[key],
                        name: fieldSurveyData?.jsonResponse[key],
                        title: "Field Survey Image",
                    });
                }
            });
        }
         if(claimDocuments){
            claimDocuments?.forEach(element => {
                if(['png', 'jpg', 'jpeg'].includes(element?.fileType)){
                    imageParamArray.push(element?.docName);
                    const docNameArray = element?.docName.split("-");
                    claimsImages.push({
                        imageText: docNameArray[0],
                        name: element?.docName,
                        title: "Claim Form",
                        url: element?.docURL,
                    });
                }
            });
        }
        if(fieldSurveyImages?.length){
            setFieldSurveyImages(prev => ({
                ...prev,
              [IMAGE_TYPE.FIELD_SURVEY]: fieldSurveyImages,
            })); 
        }
        if(claimsImages?.length){
            setFieldSurveyImages(prev => ({
                ...prev,
              [IMAGE_TYPE.CLAIM_FORM]: claimsImages,
            }));
        }
        fetchImageCoordinates(imageParamArray);
    }
    /**
     * Find field survey to retrieve the survey images uploaded from field survey app.
     * When makers on google map is clicked by user, the uploaded image on selected latitude and longitude will be displayed.
     */
    const findFieldSurvey = async ()=>{
        const result = await getClaimDocuments(claimDetailCookie?.claimNo);
        const response = await getFieldSurveyList(claimDetailCookie?.claimNo);
        if (response && response?.data !== "" && response?.data?.length) {
           const fieldSurveyData = await getFieldSurveyData(response?.data[response?.data?.length - 1].fieldSurveyId);
           prepareClaimAndFieldSurveyImageParam(fieldSurveyData?.data, result?.data);
        }else{
            prepareClaimAndFieldSurveyImageParam(null, result?.data);
        }
    }
    
    const getGISSurveyData=async (GisSurveyId)=>{
        if(!giSSurveyAPIProgressRef.current){
        giSSurveyAPIProgressRef.current = true;
            const response = await getGisSurveyUsingGISNo(GisSurveyId);
            setLoading(false)
            if(response){
                setGisSurveyData(response?.data)
                updateWaterDate(response);
                const gisData = response?.data?.jsonResponse
                saveInLocalStorage("gis_id",GisSurveyId)
                getPolygonData(response?.data?.gisSurveyId)
                const images = [...gisData?.png_msavi || [], ...gisData?.png_ndmi || [], ...gisData?.png_ndvi || []]
                setGISImages([...images])
                findFieldSurvey();
                giSSurveyAPIProgressRef.current = false;
            }
        }
    }
    useEffect(() => {
        gisSurveyList()
    }, [claimDetailCookie?.claimNo])

    const gisSurveyList = async () => {
        setLoading(true)
        const response = await getGisSurveyList(claimDetailCookie?.claimNo);
        setLoading(false);
        setGisSurveyLists(response?.data);
    }
    const onGISGraphTypeChange = (data) => {
        setGisReportName(data);
        const gisData = gisSurveyData?.jsonResponse
         if(data.value === 'all'){
            setGISImages([...gisData.png_msavi, ...gisData.png_ndmi, ...gisData.png_ndvi]);
         }else if(data.value && data.value!=='imd'){
            setGISImages([...gisData[`png_${data.value}`]])
         }
    }

    const MultiValueRemove = (props) => {
        if (fixedOptions.some(option => option.value === props.data.value)) {
          return null;
        }
        return <components.MultiValueRemove {...props} />;
    };

    const getCropHealthAndSown = (type)=>{
        const cropSown = gisSurveyData?.jsonResponse?.Crop_Sown;
        if(!cropSown){
            return '--';
        }
        const cropSownArray = cropSown.split(",");
        if(type === SOWN && cropSownArray[0]?.toLowerCase() !== 'yes'){
            return cropSown;
        } else if(type === SOWN && cropSownArray[0]?.toLowerCase() === 'yes'){
            return cropSownArray[0];
        } else if(type === HEALTH && cropSownArray[0]?.toLowerCase() === 'yes'){
            return firstLetterCapital(cropSown.replace("Yes, ", ""));
        } else {
            return '--';
        }
    }
    return (
        <>
        {
            loading ? (
                <LoadingPage/>
            ) : (
                <>
                {(claimDetailCookie)&& (
                <div className='inner-box2Field mt-3' style={{marginRight: "20px"}}>
                    <div className="detailsHistory">
                    <div className='d-flex align-items-end justify-content-between'>
                      <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">GIS Survey</h3>
                      {
                        (claimDetailCookie.claimHandler === roleDataCookie.userID || (roleDataCookie?.roleName !== "CLAIMS_HANDLER" && editModeOn(functionalities.GIS_REQUEST)))
                        && claimDetailCookie?.claimStatus?.toLowerCase() !== "closed" && claimDetailCookie?.claimStatus?.toLowerCase() !== RECLOSE && claimDetailCookie?.claimSubstatus!=="Claim Approval In-Progress"
                        && claimDetailCookie?.claimSubstatus!=="Claim Payout In-Progress" && claimDetailCookie?.claimSubstatus!== "Account Details Missing" && claimDetailCookie?.claimSubstatus!== "A/C Holder Details mismatch"
                        && claimDetailCookie?.claimSubstatus!=="Balance Check Success" && claimDetailCookie?.claimSubstatus!=="Balance Check Failed"
                        && claimDetailCookie?.claimSubstatus!=="Penny Drop Success" && claimDetailCookie?.claimSubstatus!=="Penny Drop Failed"
                        && claimDetailCookie?.claimSubstatus!=="Penny Drop Pending" && claimDetailCookie?.claimSubstatus!=="Penny Drop Returned"
                        && claimDetailCookie?.claimSubstatus!=="Penny Drop Rejected" && claimDetailCookie?.claimSubstatus!=="Penny Drop Processed"
                        && claimDetailCookie?.claimSubstatus!=="Payment Disbursement Success" && claimDetailCookie?.claimSubstatus!=="Payment Disbursement Failed"
                        && claimDetailCookie?.claimSubstatus!=="Payment Disbursement Pending" && claimDetailCookie?.claimSubstatus!=="Payment Disbursement Returned"
                        && claimDetailCookie?.claimSubstatus!=="Payment Disbursement Rejected" && claimDetailCookie?.claimSubstatus!=="Payment Disbursement Processed"
                        && claimDetailCookie?.claimSubstatus!=="Payment Success" 
                        && claimDetailCookie?.gisSurvey!=="IN_PROGRESS" && (
                            <GisSurveyRequest 
                                claimID={claimDetailCookie?.claimNo}
                                gisSurveyList={gisSurveyList}
                                getClaimDetails={getClaimDetails}
                                claimDetailCookie={claimDetailCookie}
                                roleDataCookie={roleDataCookie}
                                />
                        )
                      }
                   </div>
                        <div className="row">
                            <section className="p-4">
                             
                                {
                                    gisSurveylists && gisSurveylists.length > 0 ? (
                                        <>
                                        <div className="claim-historyGIS">
                                            <h2 id="historyGIS">GIS Survey Results</h2>
                                            <div className="overflowGIS">
                                                <table id="claim_historyGIS">
                                                    <tr>
                                                        <th style={{ textAlign: "left" }}>GIS Survey ID</th>
                                                        <th>GIS Surveyor Name</th>
                                                        <th>GIS Survey Initiated Date</th>
                                                        <th>GIS Survey Received Date</th>
                                                        <th>Aging</th>
                                                        <th>GIS Remarks</th>
                                                        <th>GIS Status</th>
                                                    </tr>
                                                    {gisSurveylists&&gisSurveylists.length>0&&gisSurveylists.map(survey=>(
                                                        <tr>
                                                        {(survey.gisStatus !== "In Progress" && survey.gisStatus !== "IN_PROGRESS" && survey.gisStatus !== "FAILED") ? <td className="claim_idGIS"><span key={survey.gisSurveyId} onClick={()=>{if(survey.gisStatus!=="In Progress" && survey.gisStatus!=="FAILED" && survey.gisStatus !== "IN_PROGRESS"){getGISSurveyData(survey?.gisSurveyId)}}}>{survey.gisSurveyId}</span></td> : <td><span key={survey.gisSurveyId}>{survey.gisSurveyId}</span></td>}
                                                        <td className="centerGIS">{survey?.jsonResponse?.GIS_Surveyor_Name?survey?.jsonResponse?.GIS_Surveyor_Name:"--"}</td>
                                                        <td className="centerGIS">{survey?.gisSurveyInitiatedDate ? format(new Date(survey?.gisSurveyInitiatedDate), 'dd-MM-yyyy, hh:mm a') : "--"}</td>
                                                        <td className="centerGIS">{survey?.gisSurveyReceivedDate ? format(new Date(survey?.gisSurveyReceivedDate), 'dd-MM-yyyy, hh:mm a') : "--"}</td>
                                                        <td className="centerGIS">{(survey?.gisSurveyInitiatedDate && survey.gisStatus !== "FAILED") ? survey?.gisSurveyReceivedDate ? formatDistance(new Date(survey?.gisSurveyInitiatedDate), new Date(survey?.gisSurveyReceivedDate)) : formatDistance(new Date(survey?.gisSurveyInitiatedDate), new Date()) : "--"}</td>
                                                        <td className="width-100">{survey?.jsonResponse?.GIS_Remarks? <ViewMoreLess text={survey?.jsonResponse?.GIS_Remarks} /> :"--"}</td>
                                                        <td className="centerGIS registerGIS">{survey.gisStatus ? <Colors status={survey.gisStatus}/> :"--"}</td>
                                                    </tr>
                                                    ))}
                                                </table>
                                            </div>
                                        </div>
                                        {
                                            gisSurveyData && gisSurveyData?.gisSurvey !=="IN_PROGRESS" && gisSurveyData?.gisSurvey !=="FAILED" && (
                                                <>
                                                    <div className="top-spaceGIS">
                                                        <div className="gis_detail_headerGIS">
                                                            <div className="gis-idGIS">{gisSurveyData?.gisSurveyId}</div>
                                                            <div className="gis-statusGIS">{gisSurveyData?.gisStatus ? gisSurveyData?.gisStatus : null}</div>
                                                            {/* <!-- current status is shown for the gis-status --> */}
                                                        </div>
                                                        <div className="container-fluid align-result-tableGIS">
                                                            <div id="result-table-rowGIS" className="row">
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        GIS Surveyor Name
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.jsonResponse?.GIS_Surveyor_Name ? gisSurveyData?.jsonResponse?.GIS_Surveyor_Name : "--"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        GIS Survey Initiated Date
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.gisSurveyInitiatedDate ? format(new Date(gisSurveyData?.gisSurveyInitiatedDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        GIS Survey Received Date
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                    {gisSurveyData?.gisSurveyReceivedDate ? format(new Date(gisSurveyData?.gisSurveyReceivedDate), 'dd-MM-yyyy, hh:mm a') : "--"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Event Occurred Type
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.jsonResponse?.Event_Occured || '--'}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Arable
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.jsonResponse?.Arable}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Crop Sown
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {getCropHealthAndSown(SOWN)}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Harvested Before Event
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.jsonResponse?.Harvested_before_event ? gisSurveyData?.jsonResponse?.Harvested_before_event : "--"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Crop Health
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {getCropHealthAndSown(HEALTH)}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Loss%
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.jsonResponse?.loss_percentage ? gisSurveyData?.jsonResponse?.loss_percentage : "--"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        Affected Area
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                        {gisSurveyData?.jsonResponse?.Damaged_area ? parseFloat(gisSurveyData?.jsonResponse?.Damaged_area).toFixed(2)  : "--"}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6">
                                                                    <div className="query-headingGIS">
                                                                        GIS Remarks
                                                                    </div>
                                                                    <div className="query-answerGIS">
                                                                       {gisSurveyData?.jsonResponse?.GIS_Remarks ? gisSurveyData?.jsonResponse?.GIS_Remarks :"--"}
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                            <>
                                                                <div id="overlayGIS">
                                                                    <div className="overlay_textGIS">Polygon Map <span onclick="off()" className="xGIS glyphicon glyphicon-remove"></span></div>
                                                                    <div className="polygon_imgGIS"><img src="/kshemaImages/map_polygon.png" alt='' /></div>
                                                                </div>
                                                                {/* {
                                                                    polygonData &&  <PolygonView polygonData={polygonData}/>
                                                                } */}
                                                                <div className="row">
                                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <Accordion defaultActiveKey={['0', '1']} alwaysOpen>
                                                                        <div className="gis_graph-boxGIS">
                                                                            <Accordion.Item eventKey="0">
                                                                                <Accordion.Header>GIS Report</Accordion.Header>
                                                                                <Accordion.Body>
                                                                                    {gisSurveyData?.jsonResponse?.dates &&  gisSurveyData?.jsonResponse?.dates !== "None" &&
                                                                                        <>
                                                                                            <div className='d-flex'>
                                                                                            <Select
                                                                                                className="select-report-name"
                                                                                                options={GIS_REPORT_TYPE_ARRAY}
                                                                                                value={gisReportName}
                                                                                                onChange={(data) => { 
                                                                                                    onGISGraphTypeChange(data) }
                                                                                                }
                                                                                            />
                                                                                                <OverlayTrigger overlay={<Tooltip>Download GIS Report</Tooltip>}>
                                                                                                    <Image
                                                                                                        id='downloadReport'
                                                                                                        className='mt-2 excel-icon ms-auto'
                                                                                                        src="/kshemaImages/excel.svg"
                                                                                                        onClick={()=>{
                                                                                                            downloadNDVI(gisSurveyData?.gisSurveyId ,gisSurveyData) 
                                                                                                        }} 
                                                                                                    />
                                                                                                </OverlayTrigger>
                                                                                                
                                                                                            </div>
                                                                                            <div className="gis_report_imgGIS">
                                                                                                {gisSurveyData && gisSurveyData?.jsonResponse?.png_msavi && 
                                                                                                    <GisSurveyChart 
                                                                                                        gisSurveyData={gisSurveyData} 
                                                                                                        gisReportName={gisReportName.value}
                                                                                                        type="all"
                                                                                                    />} 
                                                                                            </div>
                                                                                            <div className="gis_report_imgGIS">
                                                                                                <GisSurveyChart 
                                                                                                    gisSurveyData={gisSurveyData} 
                                                                                                    gisReportName={gisReportName.value}
                                                                                                    type="imd_rainfall"
                                                                                                />
                                                                                            </div>
                                                                                        </>
                                                                                    }
                                                                                    {(!gisSurveyData?.jsonResponse?.dates || gisSurveyData?.jsonResponse?.dates === "None") && 
                                                                                     <div>GIS chart data not available</div>
                                                                                    }
                                                                                    
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>
                                                                                <Accordion.Item eventKey="1">
                                                                                <Accordion.Header>Polygon View</Accordion.Header>
                                                                                    <Accordion.Body>
                                                                                        <div>
                                                                                            <div className="ms-auto d-flex">
                                                                                            <div className="">
                                                                                                    <div className="query-headingGIS">
                                                                                                    Flood Date
                                                                                                    </div>
                                                                                                        <Select
                                                                                                            className="flood-date-select mt-2"
                                                                                                            options={floodDateOptions}
                                                                                                            value={selectedFloodDate}
                                                                                                            placeholder="Select Flood Date"
                                                                                                            noOptionsMessage={() => 'Flood Date Not Found'}
                                                                                                            isClearable
                                                                                                            onChange={onSelectedFloodDateChange}
                                                                                                        />
                                                                                                </div>
                                                                                                <div className="mb-1 ms-2">
                                                                                                    <div className="query-headingGIS">
                                                                                                        Map Category
                                                                                                    </div>
                                                                                                    <Select
                                                                                                        className="categories-select-container mt-2"
                                                                                                        placeholder="Select Categories"
                                                                                                        isMulti
                                                                                                        options={mapCategoryOptions}
                                                                                                        value={mapCategory}
                                                                                                        onChange={(selected)=>{
                                                                                                        onMapCategoryChange(selected)
                                                                                                        }}
                                                                                                        closeMenuOnSelect={false}
                                                                                                        components={{ MultiValueRemove }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className='d-flex mb-2 mt-1 flex-wrap justify-content-end'>
                                                                                                <>
                                                                                                    {legendItems.map((item, index) => (
                                                                                                        <div className={`d-flex ${index !== 0 ? 'ms-2' : ''}`} key={index}>
                                                                                                        <div className={item.className}></div>
                                                                                                        <span className='legend-text'>{item.label}</span>
                                                                                                        </div>
                                                                                                    ))}
                                                                                                    <div className="d-flex ms-2">
                                                                                                        <img alt='marker' className='image-marker' src='/kshemaImages/map_marker.svg' />
                                                                                                        <span className='legend-text'>Field Survey Image</span>
                                                                                                    </div>
                                                                                                </>
                                                                                            </div>
                                                                                            
                                                                                        </div>
                                                                                        <div className='map-parent'>
                                                                                            <APIProvider apiKey={GOOGLE_MAP_API_KEY}>
                                                                                                <GMap
                                                                                                    pngMapImageArray={pngMapImageArray}
                                                                                                    polygonPositionsArray={ polygonPositionsArray }
                                                                                                    imagesLatitudeLongitude={imagesLatitudeLongitude}
                                                                                                    imageNames={imagesNameArray}
                                                                                                    mapCenter={mapCenter}
                                                                                                    onViewImageClick={(index, allImages, imageType)=>{
                                                                                                        setModalShow({
                                                                                                            canShow: true,
                                                                                                            index,
                                                                                                            allImages,
                                                                                                            imageType
                                                                                                        });
                                                                                                    }}
                                                                                                />
                                                                                            </APIProvider>
                                                                                        </div>
                                                                                    </Accordion.Body>
                                                                               </Accordion.Item>
                                                                        </div>
                                                                     </Accordion>
                                                                    </div>
                                                                    {/* <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                                                        <div className="gis_graph-boxGIS">
                                                                            <h2 className="documentsGIS gis_imgGIS">GIS Image({gisreportName})</h2>
                                                                            <div className="gis_imgsGIS">
                                                                            <section className='slider'>
                                                                                <i class = "fa fa-angle-left gis-image-scrollerGIS" onClick={prevSlide}></i> 
                                                                                {gISImages && gISImages.map((image, index) => {
                                                                                    return (
                                                                                    <div
                                                                                        className={index === current ? 'slide active' : 'slide'}
                                                                                        key={index}
                                                                                    >
                                                                                        {index === current && (
                                                                                        <img src={image} height={"320px"} width={"400px"} alt='' className='image' />
                                                                                        )}
                                                                                    </div>
                                                                                    );
                                                                                })}
                                                                              <i className = "fa fa-angle-right gis-image-scrollerGIS_right" onClick={prevSlide}></i>
                                                                            </section>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                </div>                                                                                  
                                                            </>
                                                </>
                                            )
                                        }
                                        {/* <h2 className="documentsGIS">Documents</h2>
                                        <div className="row">
                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                                <div className="align1_dataGIS survey_box1GIS">
                                                    <div className="survey_box2GIS">
                                                        <div className="uploaded_imgGIS">
                                                            
                                                        </div>
                                                    </div>
                                                    <div className="img_descriptionGIS">Digital Survey Report <span className="asteriskGIS"></span></div>
                                                </div>
                                            </div>
                                        </div>                                    */}
                                        </>
                                    ) :  <NoDataFound text={"Not Requested for GIS Survey Report"}/>
                                }
                            </section>
                        </div>
                    </div>
               </div>
            )}            
                </>
            )
        }
         <ViewImagePopup
            isOpen={modalShow?.canShow || false}
            index={modalShow?.index}
            allImages={modalShow?.allImages}
            imageType={modalShow?.imageType}
            toggle={()=>{ setModalShow({
                canShow: false,
                index: -1,
                allImages: null,
                imageType: "",
            })}}
      />
        
        </>
        
    )
}

export default GisSurvey
